// Expected return month options: next month through 12 months ahead, counted
// on the UTC calendar because that is the calendar the server validates
// against (server/services/returnMonth.js). Values are 'YYYY-MM'; '' is
// "Not sure".

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

export const NOT_SURE = '';

/** 'YYYY-MM' to 'November 2027'. Empty for anything else. */
export const formatReturnMonth = (key) => {
  const match = /^(\d{4})-(\d{2})$/.exec(String(key || ''));
  if (!match) return '';
  return `${MONTH_NAMES[Number(match[2]) - 1]} ${match[1]}`;
};

/** The 12 selectable months, as [{ value: 'YYYY-MM', label: 'Month YYYY' }]. */
export const returnMonthOptions = (now = new Date()) => {
  const options = [];
  for (let ahead = 1; ahead <= 12; ahead += 1) {
    const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + ahead, 1));
    const value = `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
    options.push({ value, label: formatReturnMonth(value) });
  }
  return options;
};
